import { Button } from "@mantine/core";
import React from "react";
import { BsTrash } from "react-icons/bs";
import { FaPhone } from "react-icons/fa";
import { MdOutlineMessage } from "react-icons/md";
import { useDispatch } from "react-redux";
import ano from "../../images/technology/ano.png";
import { deleteMessage } from "../../redux/actions/frontendActions/messageAction";
function DashboardMessageCard({ message, index }) {
  const dispatch =useDispatch();
  return (
    <div className="dashbaord_message-card" key={index}>
      <div className="top">
        <div>
          {" "}
          <img src={message.image ? message.image : ano} alt="" />
        </div>
        <div className="delete">
          <BsTrash onClick={() => dispatch(deleteMessage(message._id))} />
        </div>
      </div>

      <div className="text-area">
        <div className="name">
          <h3>
            {message.firstName} {message.lastName}
          </h3>
        </div>

        <div className="email">
          <p>email</p>
          <h6>{message.email}</h6>
        </div>
        <div className="text" style={{marginBottom:"5px"}}>
          <h5>Status</h5>
          <p>{message.status}</p>
        </div>
        <div className="text" style={{marginBottom:"5px"}}>
          <h5>Send time</h5>
          <p>{message.createdAt}</p>
        </div>
        <div className="text">
          <h5>Message , </h5>
          <p> {message.message}</p>
        </div>
        <div className="button-area-flex">
          <div>
            {" "}
           <a href={`tel:${message.phone}`}> <Button leftIcon={<FaPhone />} variant="outline" color="teal">
              Call
            </Button></a>
          </div>

          <div>
           <a href={`mailto:${message.email}`}>
           <Button
              leftIcon={<MdOutlineMessage />}
              variant="outline"
              color="pink"
            >
              Message
            </Button>
           </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardMessageCard;
